const normalize = (value) =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

/**
 * Does any column of the row contain `query`? Looks at every raw cell of the file (also the
 * columns that are not imported, e.g. phone) and at the current person fields (so an edited
 * row is found by its new values). Case and accent insensitive; blank query matches all.
 *
 * @param {{ cells: string[], person: Record<string, string> }} row
 * @param {string} query
 */
export function searchAllColumns(row, query) {
  const needle = normalize(query).trim();
  if (!needle) return true;
  return [...row.cells, ...Object.values(row.person)].some((value) => normalize(value).includes(needle));
}
